var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "collection-wrapper" }, [
    _c("div", { staticClass: "header" }, [
      _vm._v(" " + _vm._s(_vm.$t("Congratulations!")) + " "),
    ]),
    _c(
      "div",
      { staticClass: "main" },
      [
        !_vm.isEmpty(_vm.uncollectLuckyDraw) &&
        _vm.uncollectLuckyDraw.luckyDrawWinner
          ? [
              _c("CollectionFrame", {
                staticStyle: { width: "100%", height: "100%" },
                attrs: { themeColor: "red" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "label",
                      fn: function () {
                        return [_vm._v(" " + _vm._s(_vm.luckyDrawAmount) + " ")]
                      },
                      proxy: true,
                    },
                    {
                      key: "content",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "lucky-draw-content" }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/images/gift-box.webp"),
                                width: "100",
                              },
                            }),
                            _c("div", { staticClass: "badge-label" }, [
                              _c(
                                "p",
                                { attrs: { lang: _vm.config.language } },
                                [_vm._v(_vm._s(_vm.$t("Lucky draw")))]
                              ),
                              _c(
                                "p",
                                { attrs: { lang: _vm.config.language } },
                                [_vm._v(_vm._s(_vm.$t("winner")))]
                              ),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3013959462
                ),
              }),
            ]
          : !_vm.isEmpty(_vm.uncollectInstantPrize)
          ? [
              _c("CollectionFrame", {
                attrs: { themeColor: "red" },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function () {
                      return [_vm._v(" " + _vm._s(_vm.instantRebate) + " ")]
                    },
                    proxy: true,
                  },
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/gift-box.webp"),
                            width: "100",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              !_vm.isEmpty(_vm.luckyDrawTicket)
                ? _c("CollectionFrame", {
                    attrs: { themeColor: "blue" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getBadgeType(
                                      _vm.luckyDrawTicket.jackpotTicket.color
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "content",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "lucky-draw-ticket-content" },
                                [
                                  _c("div", { staticClass: "badge-label" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm
                                            .getBadgeType(
                                              _vm.luckyDrawTicket.jackpotTicket
                                                .color
                                            )
                                            .split(" ")[0]
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("img", {
                                    attrs: {
                                      src: require(`@/assets/images/${_vm.luckyDrawTicket.jackpotTicket.color}.webp`),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1000800402
                    ),
                  })
                : _vm._e(),
            ]
          : _vm._e(),
      ],
      2
    ),
    _c(
      "div",
      {
        staticClass: "collect-btn",
        on: {
          click: function ($event) {
            return _vm.$emit("jackpotPopup")
          },
        },
      },
      [_vm._v(" " + _vm._s(_vm.$t("Claim your prize")) + " ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }